import SidebarComponent from './component';

export default SidebarComponent;
